import { rest } from 'msw'
import {
  dummyConnections,
  dummyReceivedConnections,
  dummySentConnections,
  networkPartners,
  noConnections,
} from 'pages/BvnkNetwork/data/dummydata'
import { BvnkNetworkConnection, NetworkMember } from 'types/bvnkNetwork'
import { WithPaginationApiResponse } from 'types/pagination'

export const getConnections = rest.get<WithPaginationApiResponse<BvnkNetworkConnection[]>>(
  `${API_URL}/api/v1/connections/:accountReference?connection-type=CONNECTED`,
  async (req, res, ctx) => {
    return res(ctx.json(dummyConnections), ctx.status(200))
  }
)

export const getReceivedInvitations = rest.get<WithPaginationApiResponse<BvnkNetworkConnection[]>>(
  `${API_URL}/api/v1/connections/:accountReference?connection-type=RECEIVED`,
  async (req, res, ctx) => {
    return res(ctx.json(dummyReceivedConnections), ctx.status(200))
  }
)

export const getSentInvitations = rest.get<WithPaginationApiResponse<BvnkNetworkConnection[]>>(
  `${API_URL}/api/v1/connections/:accountReference?connection-type=REQUESTED`,
  async (req, res, ctx) => {
    return res(ctx.json(dummySentConnections), ctx.status(200))
  }
)

export const getEmptyConnectionsList = rest.get<WithPaginationApiResponse<BvnkNetworkConnection[]>>(
  `${API_URL}/api/v1/connections/:accountReference`,
  async (req, res, ctx) => {
    return res(ctx.json(noConnections), ctx.status(200))
  }
)

export const getNetworkMembersList = rest.get<WithPaginationApiResponse<NetworkMember[]>>(
  `${API_URL}/api/v1/connections/:accountReference/discover`,
  async (req, res, ctx) => {
    return res(ctx.json(networkPartners?.content), ctx.status(200))
  }
)

export const getEmptyNetworkMembersList = rest.get<WithPaginationApiResponse<NetworkMember[]>>(
  `${API_URL}/api/v1/connections/:accountReference/discover`,
  async (req, res, ctx) => {
    return res(ctx.json([]), ctx.status(200))
  }
)

export const postAddNetworkConnection = rest.post<{}>(
  `${API_URL}/api/v1/connections`,
  async (req, res, ctx) => {
    return res(ctx.status(200))
  }
)

export const postUpdateNetworkConnection = rest.patch<{}>(
  `${API_URL}/api/v1/connections/:connectionId`,
  async (req, res, ctx) => {
    return res(ctx.status(201))
  }
)

export default [
  getConnections,
  getEmptyConnectionsList,
  getNetworkMembersList,
  getReceivedInvitations,
  getSentInvitations,
  getEmptyNetworkMembersList,
]
